import type { CurrencyCodes } from '@onevesthq/ov-enums';
import { MenuItem } from '@ovComponents/2-component/menuItem/menuItem';
import { SelectField } from '@ovComponents/2-component/selectField/selectField';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { getCurrencyFlag } from '@utils/currency';
import { Box } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export type DepositInternalTransferCurrencySelectProp = {
  selectedCurrency?: string;
  availableCurrencies: CurrencyCodes[];
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
};

export const DepositInternalTransferCurrencySelect = ({
  selectedCurrency,
  availableCurrencies,
  focused,
  onFocus,
  onChange,
}: DepositInternalTransferCurrencySelectProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <SelectField
      fullWidth
      sx={{ mb: 2 }}
      testId='internal-transfer-currency-select'
      label={t('transfer:selectCurrency')}
      value={selectedCurrency || ''}
      onChange={(e: any) => {
        onChange({ currency: e.target.value });
        onFocus('currency');
      }}
      error={
        !selectedCurrency &&
        focused.includes('currency') &&
        availableCurrencies.length > 0
      }
    >
      {availableCurrencies.map((currency) => (
        <MenuItem
          key={currency}
          value={currency}
          data-testid={`currency-option-${currency}`}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img
              src={getCurrencyFlag(currency)}
              alt={currency}
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
            {currency}
          </Box>
        </MenuItem>
      ))}
    </SelectField>
  );
};
